module.exports = __webpack_public_path__ + "static/media/4 skull orthodox christianity dagger knife.1280x1231.97c2cc9f.webp";